module.exports = __webpack_public_path__ + "img/reject-bg.14a550d7.png";